import { UserInfo } from "../models/Interfaces";

export enum Key {
  EncryptionKey = "EncryptionKey_V1_AES-GCM_256",
  EncryptionSaltKey = "EncryptionSalt_V1",
  // Still use "UserAccount" which was the legacy key name for all user info including tokens.
  UserInfo = "UserAccount",
  Tokens = "tokens",
  Login = "persist:login",
}

export interface SecureStorage {
  updateCryptoKey(u: UserInfo, password: string): Promise<void>;
  clear(): Promise<void>;
  getItem<T>(key: string): Promise<T | null>;
  setItem<T>(key: string, value: T): Promise<T>;
  removeItem(key: string): Promise<void>;
  keys(): Promise<string[]>;
  unlock(password: string): Promise<boolean>;
}

export enum Platform {
  Browser = "Browser",
  iOS = "iOS",
  Android = "Android",
}

export enum EncryptionVersion {
  AES_GCM_256 = "AES-GCM_256",
}

export type EncryptedPayload = {
  payload: ArrayBuffer;
  iv: Uint8Array;
  // Version exists to mark what type of encryption we used for this payload.
  // This lets us upgrade in the future.
  version: EncryptionVersion;
  // Specifies if this should be in iOS, Android, or a browser
  platform: Platform;
};

export class NoEncryptionKeyError extends Error {
  constructor(msg?: string) {
    super(
      `${msg ? msg + " " : ""}There is no client encryption key. Please set a user account first.`
    );
  }
}
